import { configureStore } from '@reduxjs/toolkit';
import homesuccesscaseReducer from "./Reducers/HomeSuccessCase";
import HRTrainingInfoReducer from "../HRTraining/HRTrainingInfo";

const store = configureStore({
    reducer:{
        homesuccesscase:homesuccesscaseReducer,
        hrtraining:HRTrainingInfoReducer
    }
})

export default store;